import { Skeleton, Stack } from "@mui/material";
import { useAtom, useAtomValue } from "jotai";
import { TicketTableDrawer } from "pages/modules/home/components/TicketTableDrawer";
import { useState } from "react";
import { toOverviewCardType, trackAiHome } from "../../analytics";
import {
  HOME_SCREEN_FILTER,
  type OverviewCountCard,
  useOverviewCounts,
} from "../../hooks/useOverviewCounts";
import { dashboardScopeAtom, overviewPeriodAtom } from "../../store";
import type { OverviewPeriod } from "../../types";
import { OverviewCard } from "./OverviewCard";
import { OverviewHeader } from "./OverviewHeader";

export const DashboardOverview = () => {
  const [period, setPeriod] = useAtom(overviewPeriodAtom);
  const { cards, isLoading, resourceIds, interval } = useOverviewCounts();
  const scope = useAtomValue(dashboardScopeAtom);
  const [selectedFilterType, setSelectedFilterType] = useState<string | null>(
    null,
  );

  const handleCardClick = (card: OverviewCountCard) => {
    trackAiHome("home_overview_card_clicked", {
      card_type: toOverviewCardType(card.id),
      value_shown: card.value,
      time_filter: period,
      scope_mode: scope.mode,
      screen_mode: "legacy",
    });
    setSelectedFilterType(card.filterType);
  };

  const handlePeriodChange = (next: OverviewPeriod) => {
    if (next !== period) {
      trackAiHome("home_time_filter_changed", {
        previous_filter: period,
        new_filter: next,
      });
    }
    setPeriod(next);
  };

  return (
    <Stack sx={{ gap: "12px", width: "100%" }}>
      <OverviewHeader
        title="Overview"
        period={period}
        onPeriodChange={handlePeriodChange}
      />
      <Stack direction="row" sx={{ gap: "12px" }}>
        {cards.map((card) =>
          isLoading ? (
            <Skeleton
              key={card.id}
              variant="rounded"
              height={64}
              sx={{ flex: 1, borderRadius: "8px" }}
            />
          ) : (
            <OverviewCard
              key={card.id}
              label={card.label}
              tone={card.tone}
              value={card.value}
              scopeNote={card.scopeNote}
              onClick={() => handleCardClick(card)}
            />
          ),
        )}
      </Stack>
      {selectedFilterType && (
        <TicketTableDrawer
          open
          onClose={() => setSelectedFilterType(null)}
          filter={{
            type: selectedFilterType,
            resourceIds,
            view: period,
            // Without this the drawer ignores the period the cards were counted
            // for and lists the whole queue.
            interval,
            otherfilters: HOME_SCREEN_FILTER,
          }}
        />
      )}
    </Stack>
  );
};
